import { render } from "./SearchBar.vue?vue&type=template&id=f925608e"
import script from "./SearchBar.vue?vue&type=script&lang=ts"
export * from "./SearchBar.vue?vue&type=script&lang=ts"

import "./SearchBar.vue?vue&type=style&index=0&id=f925608e&lang=css"
script.render = render

export default script